import { Injectable } from '@angular/core';
import { API } from './api';
import { App } from 'ionic-angular';
import { BehaviorSubject } from 'rxjs';
import { BrainBankErrorCode } from './error-code';

@Injectable()
export class AuthProvider {
    private authenticated = false;
    public isAuthenticatedSubscription: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private app: App, private api: API) {}

    private async validateToken(): Promise<boolean> {
        if (this.authenticated) {
            console.log('[AuthProvider] User Token has already been verified');
            return true;
        }

        try {
            await this.api.validateToken();
            console.log('[AuthProvider] User Token verification succeeded');
            this.authenticated = true;
            this.isAuthenticatedSubscription.next(this.authenticated);
            return true;
        } catch (err) {
            console.log(err);
            if (err.error && err.error.code == BrainBankErrorCode.AccountLocked) {
                throw err;
            } else {
                console.log('[AuthProvider] User Token failed to verify');
                this.authenticated = false;
                this.isAuthenticatedSubscription.next(this.authenticated);
                return false;
            }
        }
    }

    private goToLoginPage() {
        setTimeout(() => {
            this.app.getActiveNavs()[0].setRoot('LoginPage');
        }, 0);
    }

    public async checkAuthentication(): Promise<boolean> {
        return await this.validateToken();
    }

    public resetInfo(): void {
        this.authenticated = false;
        this.isAuthenticatedSubscription.next(this.authenticated);
    }
}



// WEBPACK FOOTER //
// ./src/providers/auth.ts